import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

const popularArticles = articles.slice(0, 6);

const articleImages: Record<string, string> = {
  'article-01': 'https://readdy.ai/api/search-image?query=A%20clean%20modern%20minimalist%20workspace%20scene%20with%20a%20smartphone%20displaying%20app%20interface%20on%20a%20warm%20wooden%20desk%2C%20soft%20natural%20light%20from%20window%2C%20cream%20and%20beige%20tones%2C%20editorial%20product%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=500&seq=article-01&orientation=landscape',
  'article-02': 'https://readdy.ai/api/search-image?query=A%20modern%20iPhone%20on%20a%20minimalist%20white%20desk%20with%20a%20coffee%20cup%2C%20bright%20natural%20window%20light%2C%20clean%20cream%20background%2C%20editorial%20product%20photography%2C%20warm%20ambient%20tones&width=800&height=500&seq=article-02&orientation=landscape',
  'article-03': 'https://readdy.ai/api/search-image?query=A%20futuristic%20AI%20concept%20visualization%20with%20glowing%20amber%20data%20nodes%20on%20a%20dark%20minimalist%20background%2C%20abstract%20network%20connections%2C%20clean%20tech%20aesthetic%2C%20warm%20golden%20accents&width=800&height=500&seq=article-03&orientation=landscape',
  'article-04': 'https://readdy.ai/api/search-image?query=A%20closeup%20of%20hands%20typing%20on%20a%20laptop%20keyboard%20with%20a%20phone%20nearby%2C%20warm%20cozy%20lighting%2C%20cream%20and%20beige%20color%20palette%2C%20minimalist%20workspace%2C%20soft%20shadows&width=800&height=500&seq=article-04&orientation=landscape',
  'article-05': 'https://readdy.ai/api/search-image?query=A%20clean%20shield%20icon%20on%20a%20smartphone%20screen%20with%20soft%20glow%2C%20representing%20security%20and%20protection%2C%20warm%20minimalist%20setting%2C%20cream%20background%2C%20professional%20tech%20photography&width=800&height=500&seq=article-05&orientation=landscape',
  'article-06': 'https://readdy.ai/api/search-image?query=A%20modern%20app%20update%20notification%20concept%20on%20a%20smartphone%20screen%2C%20clean%20minimalist%20design%2C%20warm%20amber%20accents%2C%20soft%20natural%20light%2C%20cream%20background%2C%20professional%20UI%20mockup&width=800&height=500&seq=article-06&orientation=landscape',
};

export default function PopularArticlesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-4">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
              热门文章
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              大家都在看
            </h2>
          </div>
          <Link
            to="/category/xiazai-jiaocheng"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors"
          >
            查看全部文章 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {popularArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={articleImages[article.imageSeq]}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-foreground-500">{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span className="text-xs text-foreground-500">{article.readTime}阅读</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-700 transition-colors duration-300">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}